import { useQuery, useQueryClient } from "@tanstack/react-query"
import { useCallback, useContext } from "react"
import { UserContext } from "../app/context/UserContext"
import {
  AccessLevel,
  DimaFeatureShortNameEnum,
  hasUserAccessToFeature,
} from "../app/models/Authorization"
import { UserAccessRequest } from "../app/models/User"
import { digitalManagerApi } from "../services/api"

export function useAccessRequests() {
  const { user, isLoadingUser } = useContext(UserContext)

  const hasAccess =
    !!user &&
    hasUserAccessToFeature(
      user.authorizations,
      DimaFeatureShortNameEnum.BA,
      AccessLevel.Read
    )

  const { data: fetchedAccessRequests = [], isLoading: loadingEntities } = useQuery({
    queryKey: ["accessRequests"],
    queryFn: () =>
      digitalManagerApi
        .get<UserAccessRequest[]>("/backOfficeAccess/requests")
        .then((r) => r.data),
    enabled: hasAccess,
  })

  const accessRequestList = hasAccess ? fetchedAccessRequests : []

  const accessRequestsBadge = hasAccess ? accessRequestList.length : undefined

  const queryClient = useQueryClient()
  const reloadAccessRequests = useCallback(
    () => queryClient.invalidateQueries({ queryKey: ["accessRequests"] }),
    [queryClient]
  )

  return {
    accessRequestList,
    accessRequestsBadge,
    reloadAccessRequests,
    isLoadingAccessRequest: loadingEntities || isLoadingUser,
  }
}
